<template>
  <LoadOnVisible v-on:intersected="loadChartData">
    <b-card no-body>
      <b-card-header>
        <!-- title and subtitle -->
        <div>
          <b-card-title class="mb-1" title-tag="h5">
            Storefronts
          </b-card-title>
        </div>

        <!-- <span
          class="border badge badge-transparent d-none d-sm-inline-block"
          right
          no-caret
          toggle-class="p-0 mb-25"
          size="sm"
          >with Warning or Urgent Status
        </span> -->
        <!-- datepicker -->
      </b-card-header>

      <b-card-body class="p-0">
        <div class="text-center" v-if="isLoadingChartData">
          <b-spinner
            variant="primary"
            class="m-5"
            style="height: 4rem; width: 4rem"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <TableListing
          v-if="items"
            class="mt-0"
            moreCustom5Class="nopadinr"
            sticky-header
            :responsive="true"
            :fixed="false"
            head-variant="light"
            :hide-pagination-top-fields="true"
            :loading-page="isLoadingChartData"
            :items.sync="items"
            :showPaginationRow="false"
            :fields.sync="tableColumns"
            :bordered="false"
          >
          <template v-slot:cell(clientCode)="data">
            <span :class="{ 'text-danger': !data.item.shouldProcess }"
              >{{ data.item.name }}
              <i
                v-if="is('developer') &&
                    data.item.shouldProcess &&
                    !data.item.isProcessed
                "
                v-b-tooltip.hover
                class="fa fa-spinner fa-spin ml-2"
                title="Importing old Shipped and Cancelled Orders"
              />
            </span>
            <template
              v-if="data.item.notMappedProds || data.item.notMappedProdsProper"
            >
              <router-link
              :to="{
                name: 'Reports.StorefrontProductStatistics',
                query: { projectId: data.item.id, showOnlyRequiresMapping: 'true' }
              }"
                v-b-tooltip.hover
                class="d-inline-block label label-secondary"
                :title="
                  data.item.notMappedProds +
                    ' Products Are Not Mapped' +
                    (data.item.notMappedProdsProper
                      ? ', while ' +
                        data.item.notMappedProdsProper +
                        ' are marked mapped, but have no mappings at all'
                      : '.')
                "
              >
               <span class="text-warning"> <i class="fa fa-exclamation-circle " /> {{ data.item.notMappedProds }}</span>
              </router-link>
            </template>
            <template
              v-if="data.item.ordersVirtuallyFailed"
            >
              <router-link
              :to="{
                name: 'Orders.Index',
                query: { projectId: data.item.id, virtuallyFailedToFulfill: 'only' }
              }"
                v-b-tooltip.hover
                class="d-inline-block label label-primary"
                :title="
                  data.item.ordersVirtuallyFailed +
                    ' Orders Are Not Virtually Synced'
                "
              >
                <i class="fa fa-exclamation-circle text-primary" />
              </router-link>
            </template>
            <template v-if="!data.item.shouldProcess">
              <span
                v-b-tooltip.hover
                class="d-inline-block label label-secondary ml-1"
                :title="'Please Check the API keys for ShipStation!'"
              >
                <i class="fa fa-arrow-circle-down text-danger" />
              </span>
            </template>
            <template v-if="!data.item.warehouseId">
              <span
                v-b-tooltip.hover
                class="d-inline-block label label-secondary ml-1"
                :title="'Warehouse Not Set!'"
              >
                <i class="fa fa-building text-danger" />
              </span>
            </template>
          </template>
          <template v-slot:cell(oldestOrderToProcess)="data">
            <span v-if="data.item.oldestOrderToProcess">{{
              howLongAgo(data.item.oldestOrderToProcess)
            }}</span>
          </template>

          <template v-slot:cell(inventoryStatus)="data">
            <router-link
              :to="{
                name: 'Reports.StorefrontProductStatistics',
                params: { projectId: data.item.id }
              }"
            >
              <InventoryStatusBadge :inventoryStatus="data.item.inventoryStatus"></InventoryStatusBadge>
            </router-link>
          </template>

          <template v-slot:cell(ordersAwaitingPayment)="data">
            <router-link
              :to="{
                name: 'Orders.Index',
                query: {
                  projectId: data.item.id,
                  orderStatus: 'awaiting_payment'
                }
              }"
            >
              {{ data.item.ordersAwaitingPayment }}
            </router-link>
          </template>

          <template v-slot:cell(ordersOnHold)="data">
            <router-link
              :to="{
                name: 'Orders.Index',
                query: { projectId: data.item.id, orderStatus: 'on_hold' }
              }"
            >
              {{ data.item.ordersOnHold }}
            </router-link>
          </template>

          <template v-slot:cell(ordersAwaitingShipment)="data">
            <router-link
              :to="{
                name: 'Orders.Index',
                query: {
                  projectId: data.item.id,
                  orderStatus: 'awaiting_shipment'
                }
              }"
            >
              {{ data.item.ordersAwaitingShipment }}
            </router-link>
          </template>

          <template v-slot:cell(ordersPendingFullfilment)="data">
            <router-link
              :to="{
                name: 'Orders.Index',
                query: {
                  projectId: data.item.id,
                  orderStatus: 'pending_fulfillment'
                }
              }"
            >
              {{ data.item.ordersPendingFullfilment }}
            </router-link>
          </template>
          <template v-slot:cell(integrationStatus)="data">
            <ProjectIntegrationStatusBadge
                :integrationStatus="data.item.integrationStatus"
              ></ProjectIntegrationStatusBadge>
          </template>
          <template v-slot:cell(integrationSystem)="data">
            <ProjectIntegrationSystemBadge
                :integrationSystem="data.item.integrationSystem"
              ></ProjectIntegrationSystemBadge>
          </template>
          </TableListing>
        </div>
      </b-card-body>
    </b-card>
  </LoadOnVisible>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
import { TableListing, LoadOnVisible } from '@/views/components/custom';
import InventoryStatusBadge from '@/views/components/InventoryStatusBadge.vue';
import ProjectIntegrationStatusBadge from '@/views/components/ProjectIntegrationStatusBadge.vue';
import ProjectIntegrationSystemBadge from '@/views/components/ProjectIntegrationSystemBadge.vue';
export default {
  mixins: [myCommonDataMixin],
  components: {
    InventoryStatusBadge,
    TableListing: TableListing,
    LoadOnVisible,
    ProjectIntegrationStatusBadge,
    ProjectIntegrationSystemBadge
  },
  data() {
    return {
      tableOpts: {
        totalRows: 0,
        loadedAll: true
      },
      items: [],
      tableColumns: [
      { key: 'clientCode', label: 'Storefront', sortable: true },
      { key: 'integrationStatus', label: 'Status', sortable: true },
      { key: 'integrationSystem', label: 'Integration', sortable: true },
      { key: 'oldestOrderToProcess', label: 'Oldest Order', sortable: true },
      { key: 'ordersOnHold', label: 'On Hold', sortable: true },
      {
        key: 'ordersAwaitingShipment',
        label: 'Awai. Shipment',
        sortable: true
      },
      {
        key: 'ordersPendingFullfilment',
        label: 'Pending Fulfill.',
        sortable: true
      },
      { key: 'ordersShipped', label: 'Shipped', sortable: true },
      {
        key: 'ordersAwaitingPayment',
        label: 'Await. Payment',
        sortable: true
      },
      { key: 'ordersCancelled', label: 'Cancelled', sortable: true },
      { key: 'ordersCount', label: 'Total', sortable: true },
      { key: 'inventoryStatus', label: 'Inv. Status', sortable: true },
      ],
      isLoadingChartData: true
    };
  },
  created() {
    // subcomponent, do not call common data
  },
  computed: {
  },
  methods: {
    howLongAgo(timestr) {
      let tzOffseTMinutes =  -this.$store.getters['account/getUserTimezone'] * 60
      let nowOrderTime = new Date(timestr);
      let defTz = 8;
      if(this.$store.getters['account/isDST']) {
        defTz = 7;
      }
      let timeWithTz = new Date((nowOrderTime.getTime() + (defTz * 60*60000)) - tzOffseTMinutes * 60000);
      let d = new Date();
      let sAgo = parseInt((new Date() - timeWithTz) / 1000);

      let dAgo = sAgo / (24 * 3600);
      let hAgo = 0;
      sAgo = sAgo % (24 * 3600);
      hAgo = sAgo / 3600;
      sAgo = sAgo % (3600);
      let mAgo = 0;
      mAgo = parseInt(sAgo / 60);
      return parseInt(dAgo) + 'd' + parseInt(hAgo) + 'h' + mAgo+ 'm';
    },
    loadChartData() {
      this.isLoadingChartData = true;
      this.$http
        .post('/api/common/manage/storefronts/listItems', {
          loadedAll: true,
          perPage: 5000
        })
        .then(resp => {
          this.isLoadingChartData = false;
          let xAxisLabels = [];
          let dataPoints = [];
          this.items = resp.data.items;
          this.tableOpts.totalRows = this.items.length;
          // items.forEach(itm => {
          //   dataPoints.push({ x: itm.sku, y: itm.quantity });
          //   xAxisLabels.push(itm.sku);
          // });
          // this.chartData.series[0].data = dataPoints;
          // this.chartData.chartOptions.xaxis.categories = xAxisLabels;
        })
        .catch(err => {
          this.isLoadingChartData = false;
          this.items = [];
        });
    }
  },
  mounted() {
  }
};
</script>
